import type { SVGProps } from 'react'
const SvgSyHashtag = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width={24} height={24} {...props}>
		<path d="M29.7 10.3h-6.9L24 3.7c.1-.6-.3-1.2-.9-1.3-.6 0-1.2.3-1.3.9l-1.3 7.1h-6.8l1.2-6.6c.1-.6-.3-1.2-.9-1.3-.6 0-1.2.3-1.3.9l-1.3 7.1H4.7c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1H11l-1.2 6.9H2.3c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1h6.9L8 28.4c-.1.6.3 1.2.9 1.3h.2c.6 0 1-.4 1.1-.9l1.3-7.1h6.8l-1.2 6.6c-.1.6.3 1.2.9 1.3h.2c.6 0 1-.4 1.1-.9l1.3-7.1h6.7c.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1H21l1.2-6.9h7.4c.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1zm-10.9 9.2H12l1.2-6.9H20z" />
	</svg>
)
export default SvgSyHashtag
